import { useRef } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as CameraIcon } from 'assets/icons/camera.svg';
import { ReactComponent as UploadIcon } from 'assets/icons/digital-loan-document.svg';
import {
  isAllowedProofOfAddressFile,
  isProofOfAddressImage,
} from '../utils/proofOfAddressFile';

const ProofOfAddressUpload = ({
  literals,
  fileName,
  previewUrl,
  disabled = false,
  onFileSelected,
}) => {
  const fileInputRef = useRef(null);
  const cameraInputRef = useRef(null);

  const handleSelectedFile = (file, { allowPdf }) => {
    if (!file) return;
    const isValid = allowPdf
      ? isAllowedProofOfAddressFile(file)
      : isProofOfAddressImage(file);
    if (!isValid) return;
    onFileSelected(file);
  };

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    const input = event.target;
    input.value = '';
    handleSelectedFile(file, { allowPdf: true });
  };

  const handleCameraChange = (event) => {
    const file = event.target.files?.[0];
    const input = event.target;
    input.value = '';
    handleSelectedFile(file, { allowPdf: false });
  };

  const openFilePicker = () => {
    if (disabled) return;
    fileInputRef.current?.click();
  };

  const openCamera = () => {
    if (disabled) return;
    cameraInputRef.current?.click();
  };

  return (
    <div className='digital-loan-proof mt-4'>
      <p className='font-bold mb-3'>{literals.title}</p>
      {previewUrl && (
        <img
          className='digital-loan-proof__preview mb-4'
          src={previewUrl}
          alt={fileName || literals.addFile}
        />
      )}
      <button
        type='button'
        className='digital-loan-proof__dropzone mb-3'
        onClick={openFilePicker}
        disabled={disabled}
      >
        <UploadIcon className='digital-loan-proof__icon' aria-hidden='true' />
        <span>{literals.addFile}</span>
      </button>
      <p className='text-center mb-3'>{literals.or}</p>
      <button
        type='button'
        className='digital-loan-proof__camera-btn'
        onClick={openCamera}
        disabled={disabled}
      >
        <CameraIcon className='digital-loan-proof__icon' aria-hidden='true' />
        <span>{literals.openCamera}</span>
      </button>
      <input
        ref={fileInputRef}
        type='file'
        className='d-none'
        accept='image/jpeg,image/png,image/webp,application/pdf,.pdf'
        onChange={handleFileChange}
        disabled={disabled}
      />
      <input
        ref={cameraInputRef}
        type='file'
        className='d-none'
        accept='image/*'
        capture='environment'
        onChange={handleCameraChange}
        disabled={disabled}
      />
    </div>
  );
};

ProofOfAddressUpload.propTypes = {
  literals: PropTypes.object.isRequired,
  fileName: PropTypes.string,
  previewUrl: PropTypes.string,
  disabled: PropTypes.bool,
  onFileSelected: PropTypes.func.isRequired,
};

export default ProofOfAddressUpload;
